/**
 * Create-menu promo visibility for Text a Photo.
 *
 * GET /users/profile/staff-text has no dismissal field. Dismissal is stored in
 * this browser, keyed by user id, so it survives reloads and later sign-ins
 * of that user without hiding the promo for someone else on the same browser.
 */

export const staffTextCreatePromoDismissKey = (userId: number): string => `staff-text-create-promo-dismissed:${userId}`;

export const isStaffTextCreatePromoDismissed = (userId?: number | null): boolean => {
  if (userId == null || typeof localStorage === 'undefined') {
    return false;
  }

  try {
    return localStorage.getItem(staffTextCreatePromoDismissKey(userId)) === '1';
  } catch {
    return false;
  }
};

export const dismissStaffTextCreatePromo = (userId?: number | null): void => {
  if (userId == null || typeof localStorage === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(staffTextCreatePromoDismissKey(userId), '1');
  } catch {
    // Private browsing can reject storage. The header still hides the promo for this page view.
  }
};

/**
 * Shown only when Text a Photo is available and sign-up has not started.
 * Pending, failed, and confirmed states have already started, so the promo stays hidden.
 * The profile section also requires a text number; without one there is no section to open.
 */
export const shouldShowStaffTextCreatePromo = (
  profile: IStaffTextProfileResponse | null | undefined,
  isDismissed: boolean
): boolean =>
  Boolean(profile && profile.isAvailable && profile.textNumber && profile.state === 'notSignedUp' && !isDismissed);
